import { render, staticRenderFns } from "./LocationQuestion.vue?vue&type=template&id=650eacc4&scoped=true&"
import script from "./LocationQuestion.vue?vue&type=script&lang=js&"
export * from "./LocationQuestion.vue?vue&type=script&lang=js&"
import style0 from "./LocationQuestion.vue?vue&type=style&index=0&id=650eacc4&lang=scss&scoped=true&"
import style1 from "./LocationQuestion.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650eacc4",
  null
  
)

export default component.exports